export const prettyPrintFileSize = (size?: number): string =>
  `${((size ?? 0) / 1048576).toFixed(2)}`;

export const getFileUrl = (id?: string) =>
  `${process.env.PUBLIC_URL}/api/file/archival/${id}`;
